/**
 * Utilidades para procesamiento de listas y opciones
 */

const stone = "PIEDRAS";
const process = "PROCESOS";

/**
 * Obtiene lista de opciones de piedras
 * @param {Array} list - Lista de elementos
 * @returns {Array} Lista de opciones de piedras
 */
export function getListOptionsStoneList(list) {
  const procesosList = list.filter((item) => item.tipo === stone);
  const OptionsStoneList = procesosList.map((item) => ({
    id: item.codigo,
    name: item.descripcion,
  }));
  return OptionsStoneList;
}

/**
 * Obtiene lista de opciones de trabajo por tiempo
 * @param {Array} list - Lista de elementos
 * @returns {Array} Lista de opciones de trabajo por tiempo
 */
export function getListOptionsTimeWork(list) {
  const procesosList = list.filter((item) => item.tipo === process);
  const OptionsTimeWork = procesosList
    .filter((item) => item.descripcion !== "MONTAJE") 
    .sort((a, b) => a.orden - b.orden) 
    .map((item) => ({
      id: item.codigo,
      name: item.descripcion,
      tiempos: item.numeropiedras,
    }));
  
  // Agregar el proceso "Engastado Externo"
  OptionsTimeWork.push({
    id: "Engastado",
    name: "ENGASTADO-Piedra_cliente",
    tiempos: ".0000"
  });

  OptionsTimeWork.push({
    id: "Engastado",
    name: "ENGASTADO-Composturas",
    tiempos: ".0000"
  });

  return OptionsTimeWork;
}

/**
 * Obtiene lista de opciones de problemas y soluciones
 * @param {Array} list - Lista de elementos
 * @returns {Array|string} Lista de opciones de problemas y soluciones o string vacío
 */
export function getListOptionsProblemAndSolutions(list) {
  if (list != null) {
    const OptionsProblemList = list.map((item) => ({
      id: item.incidencia,
      name: item.descind,
      descsol: item.descsol,
      incidencia: item.incidencia,
      solucion: item.solucion,
      // Otros campos como name y solution si los necesitas
    }));

    return OptionsProblemList;
  } else {
    return "";
  }
}
